import { postalCodeRegExp } from "../../../../../../utils/regex";
import { addressVoivodeshipsList } from "../../../../../../helpers/voievodeshipsList";
import { RequiredInfo } from "../../../../operator-subcontractors-detail-edite/components/forms-wraper/helpers/required-info";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import styled from "styled-components";
import * as yup from "yup";
import { Input } from "../../../../../../components/Input/input";
import { theme } from "../../../../../../helpers/theme";
import { WarningMessage } from "../../../../../../components/WarningMessage";
import {WarehouseTestValue} from "../../../../operator-subcontractors-add copy/index"
import { Box, Button, IconButton, InputAdornment, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";




interface WarehouseDataAndAddressAddProps {
    actualInitialWarehouseAddValues: WarehouseTestValue;
    warehouseAddressID: string;
    warehouseID: string;
    warehouseSubcontractorConnection: boolean;
    setActualInitialWarehouseAddValues: (value: WarehouseTestValue) => void;
    setIsNextVisible: (value: boolean) => void;
    setIsBackVisible: (value: boolean) => void;
    setWarehouseAddressID: (value: string) => void;
    setwarehouseID: (value: string) => void;
    setActiveStep: (value: number) => void;
    setBackToSummary: (value: boolean) => void;
    backToSummary: boolean;

}

export const WarehouseDataAndAddressAdd = ({
    actualInitialWarehouseAddValues,
    warehouseAddressID,
    warehouseID,
    warehouseSubcontractorConnection,
    backToSummary,
    setActualInitialWarehouseAddValues,
    setIsNextVisible,
    setIsBackVisible,
    setWarehouseAddressID,
    setwarehouseID,
    setActiveStep,
    setBackToSummary
}: WarehouseDataAndAddressAddProps) => {
    const [isDataChange, setIsDataChange] = useState(false);

    const [isMedical, setIsMedical] = useState(
        actualInitialWarehouseAddValues.medyczny === true ? '0' : '1');
    const [_isMedical, set_IsMedical] = useState(isMedical);

    const [storageClass, setStorageClass] = useState(`${actualInitialWarehouseAddValues.klasa_magazynu}`);
    const [_storageClass, set_StorageClass] = useState(storageClass);

    const [showPassword, setShowPassword] = useState(false);
    const [isApiData, setIsApiData] = useState(false);

    const isApiDataComplete = (
        a: string,
        b: string,
        c: string,

    ) => {
        if (a.length > 0 && b.length > 0 && c.length > 0) {
            return setIsApiData(true);
        } else if (
            a.length === 0 && b.length === 0 && c.length === 0) {
            return setIsApiData(true);
        } else {
            return setIsApiData(false);
        }
    }


    const validationSchema = yup.object({
        kod_magazynu: yup
            .string()
            .strict()
            .max(500, "Maksymalnie 500 znaków")
            .required("Kod magazynu jest wymagany"),
        opis: yup
            .string()
            .strict()
            .max(500, "Maksymalnie 500 znaków")
            .nullable(true),
        powierzchnia_procentowa: yup
            .string()
            .matches(/^[0-9]$|^[1-9][0-9]$|^(100)$|^([0-9]){1}(\.[0-9]{1,2})?$|^([1-9][0-9])(\.[0-9]{1,2})?$/, "Błędny format danych!"),
        adres_uslugi: yup
            .string()
            .strict()
            .max(500, "Maksymalnie 500 znaków"),
        login: yup
            .string()
            .strict()
            .max(500, "Maksymalnie 500 znaków"),
        haslo: yup
            .string()
            .strict()
            .max(500, "Maksymalnie 500 znaków"),
        miejscowosc: yup
            .string()
            .strict()
            .required("Miejscowość jest wymagana")
            .max(100, "Maksymalnie 100 znaków"),
        kod_pocztowy: yup
            .string()
            .required("Kod pocztowy jest wymagany")
            .matches(postalCodeRegExp, "Błędny format!")
            .min(6, "Błędny format!")
            .max(6, "Błędny format!"),
        ulica: yup
            .string()
            .strict()
            .max(100, "Maksymalnie 100 znaków"),
        numer_budynku: yup
            .string()
            .strict()
            .required("Numer budynku jest wymagany")
            .max(5, "Maksymalnie 5 znaków"),
        numer_lokalu: yup
            .number()
            .min(1, "Minimalna wartość to 1")
            .max(99999, "Maksymalna wartość to 99999")
            .typeError("Numer lokalu od 1 do 99999"),
        wojewodztwo: yup
            .string()
            .strict()
            .required("Województwo jest wymagane")
            .max(50, "Maksymalnie 50 znaków"),
        kraj: yup
            .string()
            .strict()
            .max(70, "Maksymalnie 70 znaków"),

    });
    const handleChangeIsMedical = (event: SelectChangeEvent) => {
        setIsMedical(event.target.value as string);

    };
    const handleChangeStorageClass = (event: SelectChangeEvent) => {
        setStorageClass(event.target.value as string);

    };
    const handleGoToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const formik = useFormik({
        initialValues: {
            kod_magazynu: actualInitialWarehouseAddValues.kod_magazynu,
            opis: actualInitialWarehouseAddValues.opis,
            powierzchnia_procentowa: actualInitialWarehouseAddValues.powierzchnia_procentowa,
            klasa_magazynu: Number(_storageClass),
            medyczny: Number(_isMedical) === 0 ? true : false,
            adres_uslugi: actualInitialWarehouseAddValues.adres_uslugi,
            login: actualInitialWarehouseAddValues.login,
            haslo: actualInitialWarehouseAddValues.haslo,
            kod_pocztowy: actualInitialWarehouseAddValues.kod_pocztowy,
            miejscowosc_poczty: actualInitialWarehouseAddValues.miejscowosc_poczty,
            miejscowosc: actualInitialWarehouseAddValues.miejscowosc,
            ulica: actualInitialWarehouseAddValues.ulica,
            numer_budynku: actualInitialWarehouseAddValues.numer_budynku,
            numer_lokalu: actualInitialWarehouseAddValues.numer_lokalu,
            wojewodztwo: actualInitialWarehouseAddValues.wojewodztwo,
            kraj: actualInitialWarehouseAddValues.kraj,
        },
        validationSchema: validationSchema,


        onSubmit: (values: WarehouseTestValue) => {

            const warehouse_data_body = {
                kod_magazynu: values.kod_magazynu,
                opis: values.opis,
                powierzchnia_procentowa: values.powierzchnia_procentowa,
                klasa_magazynu: Number(storageClass),
                medyczny: (isMedical === '0' ? true : false),
                adres_id: warehouseAddressID,
                magazyn_api: {
                    adres_uslugi: values.adres_uslugi,
                    login: values.login,
                    haslo: values.haslo,
                }
            }

            const warehouse_address_body = {
                kod_pocztowy: formik.values.kod_pocztowy,
                miejscowosc_poczty: formik.values.kod_pocztowy,
                miejscowosc: formik.values.miejscowosc,
                ulica: formik.values.ulica,
                numer_budynku: formik.values.numer_budynku,
                numer_lokalu: formik.values?.numer_lokalu ? formik.values?.numer_lokalu : null,
                wojewodztwo: formik.values.wojewodztwo,
                kraj: formik.values.kraj,
            }


            if (isDataChange) {
                //postNewSubcontractorAddMutation.mutate(body)
                setActualInitialWarehouseAddValues({
                    kod_magazynu: formik.values.kod_magazynu,
                    opis: formik.values.opis,
                    powierzchnia_procentowa: formik.values.powierzchnia_procentowa,
                    klasa_magazynu: Number(storageClass),
                    medyczny: isMedical === '0' ? true : false,
                    adres_uslugi: formik.values.adres_uslugi,
                    login: formik.values.login,
                    haslo: formik.values.haslo,

                    kod_pocztowy: formik.values.kod_pocztowy,
                    miejscowosc_poczty: formik.values.miejscowosc_poczty,
                    miejscowosc: formik.values.miejscowosc,
                    ulica: formik.values.ulica,
                    numer_budynku: formik.values.numer_budynku,
                    numer_lokalu: formik.values.numer_lokalu,
                    wojewodztwo: formik.values.wojewodztwo,
                    kraj: formik.values.kraj,
                });


                set_IsMedical(isMedical);
                set_StorageClass(storageClass);

                setIsDataChange(false);
                backToSummary ? setActiveStep(2) : setActiveStep(2);
                setBackToSummary(false);
                handleGoToTop();
            }
        },
    });

    const compareValuesInFormWithStartedValues = (
        values: WarehouseTestValue,
        newValues: WarehouseTestValue) => {
        return !shallowEqual(values, newValues);
    };


    useEffect(() => {
        isApiDataComplete(
            formik.values.adres_uslugi,
            formik.values.login,
            formik.values.haslo,
        );
        setIsDataChange(isApiData);

        setIsDataChange(compareValuesInFormWithStartedValues(actualInitialWarehouseAddValues, {
            kod_magazynu: formik.values.kod_magazynu,
            opis: formik.values.opis,
            powierzchnia_procentowa: formik.values.powierzchnia_procentowa,
            klasa_magazynu: Number(storageClass),
            medyczny: isMedical === '0' ? true : false,
            adres_uslugi: formik.values.adres_uslugi,
            login: formik.values.login,
            haslo: formik.values.haslo,

            kod_pocztowy: formik.values.kod_pocztowy,
            miejscowosc_poczty: formik.values.miejscowosc_poczty,
            miejscowosc: formik.values.miejscowosc,
            ulica: formik.values.ulica,
            numer_budynku: formik.values.numer_budynku,
            numer_lokalu: formik.values.numer_lokalu,
            wojewodztwo: formik.values.wojewodztwo,
            kraj: formik.values.kraj,
        }));
    }, [formik.values]);


    useEffect(() => {
        setIsDataChange(!(isMedical === _isMedical));
    }, [isMedical]);

    useEffect(() => {
        setIsDataChange(!(storageClass === _storageClass));
    }, [storageClass]);

    useEffect(() => {
    }, [_storageClass]);

    useEffect(() => {
    }, [isDataChange]);

    return (
        <Container>
            <form
                onSubmit={formik.handleSubmit}
                onChange={() => {
                    setIsDataChange(isApiData);
                    setIsDataChange(compareValuesInFormWithStartedValues(actualInitialWarehouseAddValues, {
                        kod_magazynu: formik.values.kod_magazynu,
                        opis: formik.values.opis,
                        powierzchnia_procentowa: formik.values.powierzchnia_procentowa,
                        klasa_magazynu: Number(storageClass),
                        medyczny: isMedical === '0' ? true : false,
                        adres_uslugi: formik.values.adres_uslugi,
                        login: formik.values.login,
                        haslo: formik.values.haslo,

                        kod_pocztowy: formik.values.kod_pocztowy,
                        miejscowosc_poczty: formik.values.miejscowosc_poczty,
                        miejscowosc: formik.values.miejscowosc,
                        ulica: formik.values.ulica,
                        numer_budynku: formik.values.numer_budynku,
                        numer_lokalu: formik.values.numer_lokalu,
                        wojewodztwo: formik.values.wojewodztwo,
                        kraj: formik.values.kraj,
                    }))
                }}

            >
                <Title>Magazyn:</Title>
                <SumamryWraper key="Kod magazynu">
                    <SummaryItemValue>
                        <Input
                            label="Kod magazynu*"
                            id="kod_magazynu"
                            name="kod_magazynu"
                            value={formik.values.kod_magazynu}
                            onChange={formik.handleChange}
                            error={formik.touched.kod_magazynu && Boolean(formik.errors.kod_magazynu)}
                            helperText={formik.touched.kod_magazynu && formik.errors.kod_magazynu}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper >
                <SumamryWraper key="Opis">
                    <SummaryItemValue>
                        <Input
                            label="Opis"
                            id="opis"
                            name="opis"
                            value={formik.values.opis}
                            onChange={formik.handleChange}
                            error={formik.touched.opis && Boolean(formik.errors.opis)}
                            helperText={formik.touched.opis && formik.errors.opis}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Powierzchnia [%]">
                    <SummaryItemValue>
                        <Input
                            label="Powierzchnia [%]"
                            id="powierzchnia_procentowa"
                            name="powierzchnia_procentowa"
                            value={formik.values.powierzchnia_procentowa}
                            onChange={formik.handleChange}
                            error={formik.touched.powierzchnia_procentowa && Boolean(formik.errors.powierzchnia_procentowa)}
                            helperText={formik.touched.powierzchnia_procentowa && formik.errors.powierzchnia_procentowa}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                < SumamryWraper key="klasa_magazynu" style={{ top: "25px", marginTop: "-16px" }}>
                    <SummaryItemValue>
                        <InputLabel sx={{
                            color: `${warehouseSubcontractorConnection
                                ? "00000061"
                                : theme.colors.gray01_secondaryText}`,
                            fontSize: "12px",
                            font: `${theme.fonts.interRegular}`,
                            top: "25px",
                            left: "12px",
                            zIndex: "100",

                        }}
                        >Klasa magazynu*
                        </InputLabel>
                        <Select
                            name="klasa_magazynu"
                            id="klasa_magazynu"
                            value={storageClass}
                            onChange={handleChangeStorageClass}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            disableUnderline //usuwa podkreslenie
                            sx={{
                                width: "100%",
                                backgroundColor: "#fcfcfb",
                                borderRadius: "8px",
                                "& .Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                    borderRadius: "8px",
                                }
                            }}
                        >
                            <MenuItem value={'0'} >A++</MenuItem>
                            <MenuItem value={'1'} >A+</MenuItem>
                            <MenuItem value={'2'} >A</MenuItem>
                            <MenuItem value={'3'} >B</MenuItem>
                        </Select>
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Medyczny" style={{ top: "25px", marginTop: "-16px" }}>
                    <SummaryItemValue>
                        <InputLabel sx={{
                            color: `${warehouseSubcontractorConnection
                                ? "00000061"
                                : theme.colors.gray01_secondaryText}`,
                            fontSize: "12px",
                            font: `${theme.fonts.interRegular}`,
                            top: "25px",
                            left: "12px",
                            zIndex: "100",

                        }}
                        >Medyczny</InputLabel>
                        <Select
                            name="Medyczny"
                            id="Medyczny"
                            value={isMedical}
                            onChange={handleChangeIsMedical}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            disableUnderline //usuwa podkreslenie
                            sx={{
                                width: "100%",
                                backgroundColor: "#fcfcfb",
                                borderRadius: "8px",
                                "& .Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                    borderRadius: "8px",
                                }
                            }}
                        >
                            <MenuItem value={'0'} >Tak</MenuItem>
                            <MenuItem value={'1'} >Nie</MenuItem>
                        </Select>

                    </SummaryItemValue>
                </SumamryWraper >
                <SubTitle>API magazynu:</SubTitle>

                {!isApiData
                    ? <WarningMessage message={"Wymagany komplet informacji"} />
                    : ""
                }
                <SumamryWraper key="Adres uslugi">
                    <SummaryItemValue>
                        <Input
                            label="Adres uslugi"
                            id="adres_uslugi"
                            name="adres_uslugi"
                            value={formik.values.adres_uslugi}
                            onChange={formik.handleChange}
                            error={formik.touched.adres_uslugi && Boolean(formik.errors.adres_uslugi)}
                            helperText={formik.touched.adres_uslugi && formik.errors.adres_uslugi}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                            disabled={(warehouseID === 'no' || !warehouseSubcontractorConnection) ? false : true}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Login">
                    <SummaryItemValue>
                        <Input
                            label="Login"
                            id="login"
                            name="login"
                            value={formik.values.login}
                            onChange={formik.handleChange}
                            error={formik.touched.login && Boolean(formik.errors.login)}
                            helperText={formik.touched.login && formik.errors.login}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={(warehouseID === 'no' || !warehouseSubcontractorConnection) ? false : true}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Hasło">
                    <SummaryItemValue>
                        <Input
                            label="Hasło"
                            id="haslo"
                            name="haslo"
                            type={showPassword ? "text" : "password"}
                            value={formik.values.haslo}
                            onChange={formik.handleChange}
                            error={formik.touched.haslo && Boolean(formik.errors.haslo)}
                            helperText={formik.touched.haslo && formik.errors.haslo}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={(warehouseID === 'no' || !warehouseSubcontractorConnection) ? false : true}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                            InputProps={{
                                disableUnderline: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowPassword(!showPassword)}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>

                <Title>Lokalizacja magazynu:</Title>
                <SumamryWraper key="Kod pocztowy">
                    <SummaryItemValue>
                        <Input
                            label="Kod pocztowy*"
                            id="kod_pocztowy"
                            name="kod_pocztowy"
                            value={formik.values.kod_pocztowy}
                            onChange={formik.handleChange}
                            error={formik.touched.kod_pocztowy && Boolean(formik.errors.kod_pocztowy)}
                            helperText={formik.touched.kod_pocztowy && formik.errors.kod_pocztowy}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Miejscowość">
                    <SummaryItemValue>
                        <Input
                            label="Miejscowość*"
                            id="miejscowosc"
                            name="miejscowosc"
                            value={formik.values.miejscowosc}
                            onChange={formik.handleChange}
                            error={formik.touched.miejscowosc && Boolean(formik.errors.miejscowosc)}
                            helperText={formik.touched.miejscowosc && formik.errors.miejscowosc}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Ulica">
                    <SummaryItemValue>
                        <Input
                            label="Ulica"
                            id="ulica"
                            name="ulica"
                            value={formik.values.ulica}
                            onChange={formik.handleChange}
                            error={formik.touched.ulica && Boolean(formik.errors.ulica)}
                            helperText={formik.touched.ulica && formik.errors.ulica}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Numer budynku">
                    <SummaryItemValue>
                        <Input
                            label="Numer budynku*"
                            id="numer_budynku"
                            name="numer_budynku"
                            value={formik.values.numer_budynku}
                            onChange={formik.handleChange}
                            error={formik.touched.numer_budynku && Boolean(formik.errors.numer_budynku)}
                            helperText={formik.touched.numer_budynku && formik.errors.numer_budynku}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Numer lokalu">
                    <SummaryItemValue>
                        <Input
                            label="Numer lokalu"
                            id="numer_lokalu"
                            name="numer_lokalu"
                            value={formik.values.numer_lokalu}
                            onChange={formik.handleChange}
                            error={formik.touched.numer_lokalu && Boolean(formik.errors.numer_lokalu)}
                            helperText={formik.touched.numer_lokalu && formik.errors.numer_lokalu}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper
                    style={{ marginTop: "-18px" }}
                    key="Województwo">
                    <SummaryItemValue>
                        <InputLabel sx={{
                            color: `${warehouseSubcontractorConnection
                                ? "00000061"
                                : theme.colors.gray01_secondaryText}`,
                            fontSize: "12px",
                            font: `${theme.fonts.interRegular}`,
                            top: "25px",
                            left: "12px",
                            zIndex: "1000",


                        }}
                        >Województwo*</InputLabel>
                        <Select
                            id="wojewodztwo"
                            name="wojewodztwo"
                            value={formik.values.wojewodztwo}
                            label="Województwo"
                            onChange={formik.handleChange}
                            variant="filled"
                            disabled={warehouseSubcontractorConnection}
                            disableUnderline //usuwa podkreslenie
                            sx={{
                                width: "100%",
                                backgroundColor: "#fcfcfb",
                                borderRadius: "8px",
                                "& .Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                    borderRadius: "8px",
                                }
                            }}
                        >

                            {addressVoivodeshipsList.map((item) => (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Kraj">
                    <SummaryItemValue>
                        <Input
                            label="Kraj"
                            id="krajl"
                            name="kraj"
                            value={formik.values.kraj}
                            onChange={formik.handleChange}
                            error={formik.touched.kraj && Boolean(formik.errors.kraj)}
                            helperText={formik.touched.kraj && formik.errors.kraj}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            disabled

                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                                "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                }
                            }}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <RequiredInfo text={"Pola obowiązkowe"} />

                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>

                    <Box sx={{ flex: '1 1 auto' }} />
                    {backToSummary
                        ?
                        <Button
                            onClick={() => { setActiveStep(2); setBackToSummary(false); handleGoToTop(); }}
                            sx={{
                                color: `${theme.colors.blue02_hover}`,
                                ":hover": {
                                    color: `${theme.colors.white}`,
                                    bgcolor: `${theme.colors.blue02_hover}`,
                                },
                            }}
                        >
                            Powrót do podsumowania
                        </Button>
                        :
                        <></>
                    }
                    <Button
                        type="submit"
                        disabled={
                            !formik.isValid ||
                            !isDataChange ||
                            !isApiData

                        }
                        sx={{
                            color: `${theme.colors.blue02_hover}`,
                            ":disabled": {
                                color: `#00000061`,
                            },
                            ":hover": {
                                color: `${theme.colors.white}`,
                                bgcolor: `${theme.colors.blue02_hover}`,
                            },
                        }}

                    >
                        Dalej

                    </Button>

                </Box>
            </form >

        </Container >
    );
};
const Container = styled.div`
width:100%;
font-family:${theme.fonts.interMedium},

`;
const SumamryWraper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

const SummaryItemValue = styled.div`
padding: 5px 0px;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
overflow-wrap: break-word;
align-content: center;
white-space: break-spaces;
`;

const ButtonWraper = styled.div`
width:100%;
text-align:center;`


const Title = styled.div`
font-family: ${theme.fonts.interMedium};
font-size: 18px;
line-height: 20px;
margin-bottom:10px;
font-weight: ${theme.fontWeight.big};
padding-top:32px;
`;

const SubTitle = styled.div`
font-family: ${theme.fonts.interMedium};
font-size: 16px;
line-height: 20px;
margin-bottom:10px;
font-weight: ${theme.fontWeight.normal};
padding-top:32px;
`




